import { Maybe } from '@Types'
import { WorkModel } from '@Entities/work/work'
export const canMemberEdit = (work: WorkModel, rhId: number): boolean => {
    const membersThatCanEdit: Array<Maybe<number>> = []
    work.originalPublishers.forEach((originalPublisher) => {
        if (originalPublisher.publisherShare !== 0) {
            membersThatCanEdit.push(originalPublisher.topMemberIpId)
        } else {
            originalPublisher.administratorPublishers.forEach((administratorPublisher) => {
                if (administratorPublisher.publisherShare !== 0) {
                    membersThatCanEdit.push(administratorPublisher.topMemberIpId)
                }
            })
        }
    })

    return membersThatCanEdit.includes(rhId)
}
